import useSWR from 'swr'
import { ApiClient } from 'src/api/client'
import { NegativeBadgesResponse } from 'src/api/types/room'
import { getNegativeBadges, POST_NEGATIVE_BADGES } from 'src/api/endpoints'

export const fetchNegativeBadges = async (url: string) => {
  const res = await ApiClient.get<NegativeBadgesResponse>(url)
  return res.data?.negativeBadges || []
}

export const useNegativeBadges = (receiverCompanyId: number) =>
  useSWR(getNegativeBadges(receiverCompanyId), fetchNegativeBadges)

export const sendNegativeBadge = async (
  receiverCompanyId: number,
  reasons: string[],
  reportComment: string,
) => {
  await ApiClient.post<NegativeBadgesResponse>(POST_NEGATIVE_BADGES, {
    negative_badge: {
      receiver_company_id: receiverCompanyId,
      reasons: reasons,
      report_comment: reportComment,
    },
  })
}
